var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-ticket__Action Type=New ticket, State=Enabled, Size=24",
    className: "new-ticket__Action new-ticket__Type=New new-ticket__ticket, new-ticket__State=Enabled, new-ticket__Size=24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-ticket__Vector",
    className: "new-ticket__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.982 8.853V6.23H15.19a.812.812 0 0 1 0-1.625h2.792V1.982a.813.813 0 0 1 1.625 0v2.623h2.411l.083.005a.813.813 0 0 1 0 1.616l-.083.004h-2.411v2.623a.812.812 0 0 1-1.625 0ZM8.533 4.358c.453 0 .887.178 1.21.495l9.301 9.138c1.005.987.468 2.696-.92 2.932l-3.545.602a.248.248 0 0 0-.202.203l-.61 3.66c-.231 1.388-1.939 1.93-2.93.93L1.669 13.05a1.726 1.726 0 0 1-.49-1.045l-.009-.169V6.083c0-.953.773-1.725 1.726-1.725h5.638Zm-5.885 7.478.005.048a.25.25 0 0 0 .067.126l9.17 9.268a.247.247 0 0 0 .418-.133l.61-3.66a1.726 1.726 0 0 1 1.414-1.418l3.544-.602a.247.247 0 0 0 .131-.419L8.706 5.907a.247.247 0 0 0-.173-.07H2.895a.247.247 0 0 0-.247.247v5.752Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.868 9.352a.673.673 0 1 0-1.346.002.673.673 0 0 0 1.346-.002Zm.986 0a1.66 1.66 0 1 1-3.32-.001 1.66 1.66 0 0 1 3.32 0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTicket);
export default __webpack_public_path__ + "static/media/new_ticket.8c324acba8ba4f622a72538e67e46453.svg";
export { ForwardRef as ReactComponent };